import React from 'react'
import styles from './notification-loader.styl'

const CardLoader = () => (
  <div className={styles.wrap}>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
    <div className={styles.loader}>
      <div className={styles.line} />
      <div className={styles.paragraph} />
      <div className={styles.date} />
    </div>
  </div>
)

CardLoader.defaultProps = {}

export default CardLoader
